import type { NextPaymentDate, PayrollReceipt } from './types';

/** Hardcoded PDF URL for all receipts until replaced by query/mutation. */
const MOCK_PDF_URL =
  'https://static.crehana.com/payroll/nomina-crehana-2026.pdf';

/** Next payment: design "15 de May. del 2025". */
export const mockNextPayment: NextPaymentDate = {
  nextPaymentDate: '2025-05-15',
  isEstimated: true,
};

/** Receipts in design order (most recent first). Quincenal: 1-15 y 16-fin de mes. */
export const mockReceipts: PayrollReceipt[] = [
  {
    id: 'receipt-7',
    startDate: '2026-02-01',
    endDate: '2026-02-14',
    periodNumber: 7,
    paymentType: 'Quincenal',
    pdfUrl: MOCK_PDF_URL,
    status: 'available',
  },
  {
    id: 'receipt-6',
    startDate: '2026-01-16',
    endDate: '2026-01-31',
    periodNumber: 6,
    paymentType: 'Quincenal',
    pdfUrl: MOCK_PDF_URL,
    status: 'available',
  },
  {
    id: 'receipt-5',
    startDate: '2026-01-01',
    endDate: '2026-01-15',
    periodNumber: 5,
    paymentType: 'Quincenal',
    pdfUrl: MOCK_PDF_URL,
    status: 'available',
  },
  {
    id: 'receipt-4',
    startDate: '2025-12-16',
    endDate: '2025-12-31',
    periodNumber: 4,
    paymentType: 'Quincenal',
    pdfUrl: MOCK_PDF_URL,
    status: 'available',
  },
];
